import toastr from "toastr";
// NOTE: toastr をグローバルに公開（レガシーコードから window.toastr でアクセスできるようにする）
window.toastr = toastr;
